import moment from 'moment';
import updateCandidate from './updateCandidate.async';

export default async function updateCandidateManually({
  id,
  update = {},
  key = 'updateCandidateManually',
  ...options
}) {
  update.manuallyUpdatedAt = moment().toISOString();
  return updateCandidate({
    ...options,
    id,
    update,
    key
  });
}
